(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stuburt-ad-mark"] && !Shopify.designMode) return;
  try {
    (function () {
    var MODE = 'consent';                 // 'consent' | 'all' — see the doc block above. 'all' 2026-09-12 → back to 'consent' 2026-10-31 (operator: "take this off"): 'all' stored the ad on the device after a Decline
    var KEY = 'stb-ad-mark';              // localStorage carrier: landing click -> cart
    var WRITTEN = 'stb-ad-mark-written';  // sessionStorage: last value written, this tab
    var WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
    var nativeFetch = window.fetch;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function cartExists() {
      return /(^|;\s*)cart=/.test(document.cookie);
    }
    function clean(v, max) {
      return String(v || '').replace(/[^\w\-\.\/]/g, '').slice(0, max || 80);
    }
    function digits(v) {
      return /^\d{6,30}$/.test(String(v || '')) ? String(v) : '';
    }

    // The ad click on THIS page's URL, if it is one. Our links always carry the pair;
    // a Meta click without it (old ad, or Meta stripped the params) still counts as
    // an ad visit, with the ad id unknown.
    function parseLanding() {
      var q = {};
      try {
        new URLSearchParams(window.location.search).forEach(function (v, k) { q[k] = v; });
      } catch (e) { return null; }
      var ad = digits(q.h_ad_id);
      var src = String(q.utm_source || '').toLowerCase();
      var med = String(q.utm_medium || '').toLowerCase();
      var isMeta = !!ad || src === 'meta' || src === 'facebook' || src === 'instagram' || src === 'ig' ||
                   med === 'paid_social' || ('fbclid' in q);
      if (!isMeta) return null;
      return {
        ad: ad || 'unknown',
        adset: digits(q.fbc_id),
        utm: clean((q.utm_campaign || '') + '/' + (q.utm_content || '')),
        ts: new Date().toISOString().slice(0, 16)
      };
    }
    var pending = parseLanding();

    function consentOK() {
      if (MODE === 'all') return true;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      try {
        var reg = cp.getRegulation && cp.getRegulation();
        var decision = cp.getTrackingConsent && cp.getTrackingConsent();
        var show = cp.shouldShowBanner && cp.shouldShowBanner();
        if ((!reg || reg === 'none') && decision === 'no_interaction' && !show) return true;   // not required here
      } catch (e) {}
      try { return !!cp.analyticsProcessingAllowed(); } catch (e) { return false; }
    }

    function load() {
      try {
        var m = JSON.parse(window.localStorage.getItem(KEY) || 'null');
        if (m && m.exp && m.exp < Date.now()) { window.localStorage.removeItem(KEY); return null; }
        return m;
      } catch (e) { return null; }
    }
    function save(m) {
      try { window.localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
    }

    // Move this page's click into the carrier once consent allows: first click kept,
    // last click updated. Runs at most once per page.
    function absorb() {
      if (!pending || !consentOK()) return;
      var m = load() || {};
      if (!m.ad) {
        m.ad = pending.ad; m.adset = pending.adset; m.utm = pending.utm; m.ts = pending.ts;
        m.exp = Date.now() + WINDOW_MS;
      }
      m.last = pending.ad;
      save(m);
      pending = null;
    }

    function lastWritten() {
      try { return window.sessionStorage.getItem(WRITTEN); } catch (e) { return null; }
    }
    function remember(sig) {
      try { window.sessionStorage.setItem(WRITTEN, sig); } catch (e) {}
    }

    var inFlight = false;

    function flush() {
      absorb();
      if (inFlight || !cartExists()) return;
      var m = load();
      if (!m || !m.ad) return;
      var attrs = {
        _stb_ad: m.ad, _stb_adset: m.adset || '', _stb_ad_utm: m.utm || '',
        _stb_ad_ts: m.ts || '', _stb_ad_last: m.last || m.ad
      };
      var sig = JSON.stringify(attrs);
      if (sig === lastWritten()) return;

      inFlight = true;
      nativeFetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) {
        if (r && r.ok) remember(sig);
      }).catch(function () {
        // Never surface an attribution failure to a shopper mid-purchase.
      }).then(function () {
        inFlight = false;
      });
    }

    // The cart usually appears AFTER the landing click (add to cart), so flush on every
    // cart mutation — without re-triggering on our own attribute write.
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = '';
        try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
        var out = nativeFetch.apply(this, arguments);
        try {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && url.indexOf('_stb_ad') === -1 &&
              !(init && typeof init.body === 'string' && init.body.indexOf('_stb_ad') !== -1)) {
            out.then(function () { setTimeout(flush, 0); }).catch(function () {});
          }
        } catch (e) {}
        return out;
      };
    }

    // The banner hides first and calls setTrackingConsent afterwards, so the API can
    // still read the old state when the event fires. Poll briefly, as the probe does.
    function afterChoice() {
      var tries = 0;
      (function again() {
        tries += 1;
        absorb();
        if (!pending || tries > 12) { flush(); return; }
        setTimeout(again, 250);
      })();
    }

    document.addEventListener('stb:consent-resolved', afterChoice);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    window.addEventListener('pageshow', flush);

    function start() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp || MODE === 'all') { flush(); return; }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { flush(); }
        );
        return;
      }
      flush();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stuburt-consent-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('stb-consent');
    if (!root) return;

    // Let deferred overlays (e.g. the welcome popup) know the consent choice is
    // settled so they never stack on top of this banner. Fired on a choice AND
    // when the banner decides not to show at all.
    function resolved() {
      try { window.__stbConsentResolved = true; } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('stb:consent-resolved')); } catch (e) {}
    }

    function hide() {
      root.classList.remove('stb-consent--visible');
      root.hidden = true;
      document.documentElement.classList.remove('stb-consent-open');
      resolved();
    }

    function remember() {
      try { window.localStorage.setItem('stb-consent-choice', '1'); } catch (e) {}
    }

    function apply(consent) {
      consent.sale_of_data = consent.marketing;
      remember();
      // Hide immediately — the consent API round-trip can take seconds and the
      // banner lingering after a click reads as a dead click. The choice is
      // already in localStorage, so a failed API call can't re-show it.
      hide();
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
      } catch (e) {}
    }

    var acceptBtn = root.querySelector('[data-stb-accept]');
    var declineBtn = root.querySelector('[data-stb-decline]');
    var manageBtn = root.querySelector('[data-stb-manage]');
    var saveBtn = root.querySelector('[data-stb-save]');
    var prefs = root.querySelector('[data-stb-prefs]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        apply({ analytics: true, marketing: true, preferences: true });
      });
    }
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        apply({ analytics: false, marketing: false, preferences: false });
      });
    }
    if (manageBtn && prefs) {
      manageBtn.addEventListener('click', function () {
        var willOpen = prefs.hidden;
        prefs.hidden = !willOpen;
        manageBtn.setAttribute('aria-expanded', String(willOpen));
        if (saveBtn) saveBtn.hidden = !willOpen;
      });
    }
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var a = root.querySelector('#stb-c-analytics');
        var m = root.querySelector('#stb-c-marketing');
        var p = root.querySelector('#stb-c-preferences');
        apply({
          analytics: !!(a && a.checked),
          marketing: !!(m && m.checked),
          preferences: !!(p && p.checked)
        });
      });
    }

    function show() {
      root.hidden = false;
      // Marker only — no longer a scroll lock. The PDP sticky ATC keys off
      // this to stay off-screen while the card is up, since the card sits
      // exactly where that buy bar does on mobile.
      document.documentElement.classList.add('stb-consent-open');
      requestAnimationFrame(function () {
        root.classList.add('stb-consent--visible');
      });
    }

    function gate() {
      try {
        if (window.localStorage.getItem('stb-consent-choice')) { resolved(); return; }
      } catch (e) {}
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function') { resolved(); return; }
      try {
        if (cp.shouldShowBanner()) {
          show();
        } else {
          resolved();
        }
      } catch (e) { resolved(); }
    }

    // "Cookie settings" (footer, or any [data-stb-cookie-settings]) reopens the
    // card with the preferences panel open and the shopper's current choice
    // ticked, so withdrawing consent is as easy as giving it (UK PECR). Saving
    // goes through apply() like any first choice. 2026-10-31.
    function reopen() {
      var current = {};
      try { current = window.Shopify.customerPrivacy.currentVisitorConsent() || {}; } catch (e) {}
      function on(v) { return v === true || v === 'yes'; }
      var boxes = { analytics: '#stb-c-analytics', marketing: '#stb-c-marketing', preferences: '#stb-c-preferences' };
      Object.keys(boxes).forEach(function (k) {
        var box = root.querySelector(boxes[k]);
        if (box) box.checked = on(current[k]);
      });
      if (prefs) prefs.hidden = false;
      if (manageBtn) manageBtn.setAttribute('aria-expanded', 'true');
      if (saveBtn) saveBtn.hidden = false;
      show();
      try { (saveBtn || root).focus({ preventScroll: true }); } catch (e) {}
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest && event.target.closest('[data-stb-cookie-settings]');
      if (!trigger) return;
      event.preventDefault();
      reopen();
    });

    if (window.Shopify && window.Shopify.customerPrivacy) {
      gate();
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error) gate();
          else resolved();
        }
      );
    } else {
      resolved();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stuburt-consent-probe"] && !Shopify.designMode) return;
  try {
    (function () {
    var ATTR = '_stb_consent';
    var MARK = 'stb-consent-probe-written';   // last value successfully written, this tab
    var nativeFetch = window.fetch;           // our own writes must not re-trigger the observer

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    // Only ever write when the shopper already has a cart. Every order has one, so
    // this costs nothing in coverage and saves a request on every bounce.
    function cartExists() {
      return /(^|;\s*)cart=/.test(document.cookie);
    }

    function granted(v) {
      return v === true || v === 'yes';
    }
    function refused(v) {
      return v === false || v === 'no';
    }

    // Was the card actually put in front of this shopper on this visit? Captured at
    // first classify, because shouldShowBanner() flips to false once they answer.
    var sawBanner = null;

    function classify() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.getTrackingConsent !== 'function') return 'no-api';

      var decision, consent, shouldShow, regulation, flag = false;
      try { decision = cp.getTrackingConsent(); } catch (e) { return 'no-api'; }
      try { regulation = cp.getRegulation && cp.getRegulation(); } catch (e) {}
      try { consent = cp.currentVisitorConsent() || {}; } catch (e) { consent = {}; }
      try { shouldShow = !!cp.shouldShowBanner(); } catch (e) { shouldShow = false; }
      try { flag = !!window.localStorage.getItem('stb-consent-choice'); } catch (e) {}

      if (sawBanner === null) sawBanner = shouldShow;

      if (decision === 'no_interaction') {
        if (!shouldShow) {
          // Nothing is being asked of them. Either no regulation applies here, or
          // our own flag is suppressing a card Shopify still wants answered.
          // The regulation check matters: without it, a shopper in a no-consent
          // region who once clicked the card reads as `stale-flag`, and that is
          // the one value we want to be able to trust on sight.
          var regulated = !!regulation && regulation !== 'none';
          return (flag && regulated) ? 'stale-flag' : 'not-required';
        }
        return 'ignored';
      }

      var yes = granted(consent.analytics) && granted(consent.marketing) && granted(consent.preferences);
      var no = refused(consent.analytics) && refused(consent.marketing) && refused(consent.preferences);
      var answer = yes ? 'accept' : (no ? 'decline' : 'partial');
      return sawBanner ? answer : 'prior-' + answer;
    }

    function lastWritten() {
      try { return window.sessionStorage.getItem(MARK); } catch (e) { return null; }
    }
    function remember(value) {
      try { window.sessionStorage.setItem(MARK, value); } catch (e) {}
    }

    var inFlight = false;

    function flush() {
      if (inFlight || !cartExists()) return;
      var value = classify();
      if (!value || value === lastWritten()) return;

      inFlight = true;
      var body = { attributes: {} };
      body.attributes[ATTR] = value;

      nativeFetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r && r.ok) remember(value);
      }).catch(function () {
        // Never surface a tracking-diagnostic failure to a shopper mid-purchase.
      }).then(function () {
        inFlight = false;
      });
    }

    // The cart may not exist at consent time and the consent may change after the
    // cart does, so flush on both edges: any cart mutation, and any consent event.
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = '';
        try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
        var out = nativeFetch.apply(this, arguments);
        try {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && url.indexOf(ATTR) === -1) {
            out.then(function () { setTimeout(flush, 0); }).catch(function () {});
          }
        } catch (e) {}
        return out;
      };
    }

    // apply() in the banner hides the card and calls setTrackingConsent afterwards,
    // so the API still reads the OLD state at the moment the event fires. Poll a
    // few times rather than recording a stale answer.
    function flushAfterChoice() {
      var tries = 0;
      (function again() {
        tries += 1;
        var value = classify();
        if (value !== 'ignored' || tries > 12) { flush(); return; }
        setTimeout(again, 250);
      })();
    }

    document.addEventListener('stb:consent-resolved', flushAfterChoice);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    window.addEventListener('pageshow', flush);

    function start() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp) { flush(); return; }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { flush(); }
        );
        return;
      }
      flush();   // records no-api, which is itself worth knowing
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
